export default __webpack_public_path__ + "static/media/DNo.4-1.999550ff.jpg";